export class DeleteReservationRequestModel {
	Id: number;
	TimeTableId: number;
}